import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../index";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../spinner";
import Cookies from 'js-cookie';
import BookStatus from "../niulSium/bookStatus";
import LearnersListAher from "../niulSium/learnersListAher";

const DisplaySiumAher = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [sium, setSium] = useState(null);
    const [mappingData, setMappingData] = useState(null);
    const [learningPiecesWithStats, setLearningPiecesWithStats] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [stats, setStats] = useState({ total: 0, taken: 0, learned: 0 });
    const [activeTab, setActiveTab] = useState("bookStatus"); // "bookStatus" or "learnersList"

    useEffect(() => {
        const fetchDisplayData = async () => {
            try {
                // Get display document
                const displayRef = doc(db, "displaySiumAher", params.displayId);
                const displaySnap = await getDoc(displayRef);

                if (!displaySnap.exists()) {
                    navigate("/");
                    return;
                }

                const displayData = displaySnap.data();

                // Get sium data
                const siumRef = doc(db, "siumimAher", displayData.siumId);
                const siumSnap = await getDoc(siumRef);

                if (!siumSnap.exists()) {
                    navigate("/");
                    return;
                }

                const siumData = { ...siumSnap.data(), id: siumSnap.id };
                setSium(siumData);

                // Check if admin
                const cookieSiumId = Cookies.get('siumShasId');
                setIsAdmin(cookieSiumId === siumData.id);

                // Get mapping data
                if (siumData.mipuiId) {
                    const mipuiRef = doc(db, "mipui", siumData.mipuiId);
                    const mipuiSnap = await getDoc(mipuiRef);
                    if (mipuiSnap.exists()) {
                        setMappingData(mipuiSnap.data());
                    }
                }

                // Build learning pieces with stats from display data
                let totalCount = 0;
                let takenCount = 0;
                let learnedCount = 0;

                if (displayData.learningPieces) {
                    const piecesWithStats = displayData.learningPieces.map(piece => {
                        totalCount++;
                        if (piece.taken) takenCount++;
                        if (piece.learned) learnedCount++;
                        return piece;
                    });
                    setLearningPiecesWithStats(piecesWithStats);
                }

                setStats({ total: totalCount, taken: takenCount, learned: learnedCount });

            } catch (error) {
                console.error("Error fetching display data:", error);
                navigate("/");
            }
        };

        fetchDisplayData();
    }, [params.displayId, navigate]);

    if (!sium || !mappingData) {
        return <Spinner />;
    }

    const bookName = mappingData?.bookName || "ספר";
    const hasFreeSpots = stats.taken < stats.total;
    const hideLomdim = sium.hideLomdim || false;

    return (
        <div className="sium-main">
            <div className="sium-main-container">
                <div className={isAdmin ? "basad-with-return" : ""}>
                    <div className="basad">
                        <span>בס"ד</span>
                        <br />
                        <span>להצלחת עם ישראל</span>
                    </div>
                    {isAdmin && (
                        <div className="return-container">
                            <a className="btn sium-button return-button"
                               href={"/niulSiumAher/" + sium.id + "/siumStatus"}>חזור</a>
                        </div>
                    )}
                </div>

                <div className="sium-logo">
                    <div className="sium-logo-img" onClick={() => navigate("/")} aria-label="Home page" role="button" style={{cursor: 'pointer'}}></div>
                </div>

                <div className="grid p-3 text-primary-emphasis bg-primary-subtle border border-primary-subtle rounded-3 sium-titles">
                    {sium.nishmat && <span>הלימוד {sium.nishmat}</span>}
                    <h2>חלוקת {bookName} של {sium.kehilaName}</h2>
                    {sium.logo && <div className={sium.logo} />}
                </div>

                <div id="displayOptions" className="sium-status-options-container">
                    <div>
                        {/* Add Learner Button - only show if free spots exist */}
                        {hasFreeSpots && (
                            <div
                                className="sium-status-option"
                                onClick={() => window.location = "/addUserAher/" + sium.id}
                                tabIndex={0}
                            >
                                <svg fill="#414a87" height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g>
                                            <g>
                                                <path d="M503.292,210.719H398.127l-2.721-33.724c-0.005-0.053-0.015-0.104-0.021-0.157c-0.003-0.031-0.007-0.062-0.01-0.092 l-8.003-99.08c-0.365-4.522-4.141-8.007-8.68-8.007H133.303c-4.537,0-8.314,3.484-8.68,8.007l-2.457,30.415 c-0.387,4.794,3.185,8.994,7.979,9.381c4.807,0.389,8.993-3.185,9.381-7.979l1.81-22.408h229.323l6.617,81.912h-16.777 c-4.81,0-8.708,3.899-8.708,8.708s3.898,8.708,8.708,8.708h18.195l1.962,24.312H131.344l1.966-24.312h198.163 c4.81,0,8.708-3.899,8.708-8.708s-3.898-8.708-8.708-8.708H134.718l2.356-29.139c0.387-4.794-3.185-8.994-7.979-9.381 c-4.803-0.385-8.994,3.186-9.381,7.979l-5.845,72.273H8.708c-4.809,0-8.708,3.899-8.708,8.708s3.899,8.708,8.708,8.708h101.747 c-1.457,1.996-3.484,3.93-6.064,6.31c-6.083,5.611-14.414,13.295-14.414,27.819c0,14.525,8.331,22.209,14.414,27.82 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.588-3.02,9.68-8.807,15.018c-6.083,5.611-14.414,13.295-14.414,27.82 s8.331,22.21,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,6.59-3.02,9.683-8.807,15.022 c-6.083,5.611-14.414,13.298-14.414,27.822c0,4.809,3.899,8.708,8.708,8.708s8.708-3.899,8.708-8.708 c0-6.59,3.02-9.682,8.807-15.022c6.083-5.611,14.414-13.297,14.414-27.822c0-14.525-8.331-22.211-14.414-27.822 c-5.787-5.339-8.807-8.432-8.807-15.022c0-6.588,3.02-9.681,8.807-15.019c6.084-5.611,14.414-13.295,14.414-27.819 c0-14.525-8.331-22.209-14.414-27.82c-5.787-5.339-8.807-8.43-8.807-15.019c0-6.588,3.02-9.68,8.807-15.018 c4.73-4.363,10.804-9.998,13.278-19.111h253.047c2.474,9.113,8.548,14.748,13.278,19.111c5.787,5.339,8.807,8.43,8.807,15.018 c0,6.589-3.02,9.681-8.807,15.019c-6.083,5.611-14.414,13.296-14.414,27.82s8.332,22.209,14.414,27.819 c5.787,5.339,8.807,8.43,8.807,15.019c0,6.59-3.02,9.682-8.807,15.022c-6.083,5.611-14.414,13.298-14.414,27.822 c0,14.525,8.332,22.211,14.414,27.822c5.787,5.339,8.807,8.432,8.807,15.022c0,4.809,3.898,8.708,8.708,8.708 c4.81,0,8.708-3.899,8.708-8.708c0-14.525-8.331-22.21-14.413-27.822c-5.788-5.339-8.808-8.432-8.808-15.022 c0-6.59,3.02-9.683,8.808-15.022c6.083-5.611,14.413-13.298,14.413-27.822s-8.332-22.209-14.414-27.82 c-5.787-5.339-8.807-8.43-8.807-15.018c0-6.589,3.02-9.681,8.807-15.019c6.083-5.611,14.414-13.296,14.414-27.82 c0-14.524-8.332-22.209-14.414-27.819c-2.58-2.38-4.607-4.315-6.064-6.31h101.747c4.81,0,8.708-3.899,8.708-8.708 S508.102,210.719,503.292,210.719z"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                <span>הוסף לומד</span>
                            </div>
                        )}

                        {/* Book Status Button */}
                        <div
                            className={`sium-status-option ${activeTab === 'bookStatus' ? 'active' : ''}`}
                            onClick={() => setActiveTab('bookStatus')}
                            aria-expanded={activeTab === 'bookStatus'}
                            aria-controls="bookStatus"
                            tabIndex={0}
                        >
                            <svg className="margin-right-10" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" fill="#414a87" stroke="#414a87">
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <title>torah</title>
                                    <g id="torah">
                                        <circle cx="8.5" cy="5.5" r="2.5" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></circle>
                                        <path d="M17,14V57.016A2.984,2.984,0,0,0,19.984,60H60V18H21a4.272,4.272,0,0,1-4-4.5h0A4.272,4.272,0,0,1,21,9H60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path>
                                        <line x1="60" y1="12" x2="34" y2="12" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <line x1="37" y1="15" x2="23" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <line x1="40" y1="15" x2="44" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <line x1="60" y1="15" x2="53" y2="15" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <polygon points="39 29 30.34 44 47.66 44 39 29" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon>
                                        <polygon points="39 49 30.34 34 47.66 34 39 49" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></polygon>
                                        <line x1="20" y1="18" x2="20" y2="60" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <path d="M28,60V56a4,4,0,0,1-4-4H20" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path>
                                        <path d="M28,18.355V22a4,4,0,0,0-4,4H20.308" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></path>
                                        <path d="M52,60V56a4,4,0,0,0,4-4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path>
                                        <path d="M52,18v4a4,4,0,0,1,4,4h4" style={{fill:"none",stroke:"#414a87",strokeLinejoin:"round",strokeWidth:"2px"}}></path>
                                        <line x1="39" y1="25" x2="39" y2="23" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <line x1="39" y1="53" x2="39" y2="55" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <circle cx="11.044" cy="23.014" r="1.069"></circle>
                                        <line x1="7" y1="37" x2="10" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                        <line x1="10" y1="37" x2="7" y2="40" style={{fill:"none", stroke: "#414a87", strokeLinecap: "round",strokeLinejoin:"round",strokeWidth: "2px"}}></line>
                                    </g>
                                </g>
                            </svg>
                            <span>מצב הלימוד</span>
                        </div>

                        {/* Learners List Button - only show if not hiding learners */}
                        {!hideLomdim && (
                            <div
                                className={`sium-status-option ${activeTab === 'learnersList' ? 'active' : ''}`}
                                onClick={() => setActiveTab('learnersList')}
                                aria-expanded={activeTab === 'learnersList'}
                                aria-controls="learnersList"
                                tabIndex={0}
                            >
                                <svg height="200px" width="200px" version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="#414a87">
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g>
                                            <path d="M6,7H0.9C0.4,7,0,7.4,0,7.9v9.1C0,17.6,0.4,18,0.9,18H6c1.7,0,3,1.3,3,3V10C9,8.3,7.7,7,6,7z"></path>
                                            <path d="M18.1,7H13c-1.7,0-3,1.3-3,3v11c0-1.7,1.3-3,3-3h5.1c0.5,0,0.9-0.4,0.9-0.9V7.9C19,7.4,18.6,7,18.1,7z"></path>
                                        </g>
                                        <path d="M31.9,17.6L29,11.8C28.9,6.4,24.4,2,19,2c-2.8,0-5.4,1.2-7.3,3.2C12.1,5.1,12.5,5,13,5h5.1C19.7,5,21,6.3,21,7.9v9.1 c0,1.6-1.3,2.9-2.9,2.9H13c-0.6,0-1,0.4-1,1v6c0,0.5,0.3,0.9,0.8,1l10,2c0.1,0,0.1,0,0.2,0c0.2,0,0.5-0.1,0.6-0.2 c0.2-0.2,0.4-0.5,0.4-0.8v-4h2c1.7,0,3-1.3,3-3v-3h2c0.3,0,0.7-0.2,0.9-0.5S32,17.9,31.9,17.6z"></path>
                                    </g>
                                </svg>
                                <span>רשימת לומדים</span>
                            </div>
                        )}
                    </div>

                    {/* Book Status Collapse Section */}
                    <div className={`collapse ${activeTab === 'bookStatus' ? 'show' : ''}`} id="bookStatus">
                        <div className="card card-body">
                            <BookStatus
                                mappingData={mappingData}
                                learningPieces={learningPiecesWithStats}
                                sium={sium}
                                siumId={sium.id}
                                isDisplayMode={true}
                            />
                        </div>
                    </div>

                    {/* Learners List Collapse Section - only show if not hiding learners */}
                    {!hideLomdim && (
                        <div className={`collapse ${activeTab === 'learnersList' ? 'show' : ''}`} id="learnersList">
                            <div className="card card-body">
                                <LearnersListAher
                                    sium={sium}
                                    mappingData={mappingData}
                                    siumId={sium.id}
                                    isDisplayMode={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="sium-bottom-page">
                <a className="margin-left-10 no-link" href="/">חזרה לדף הבית</a>
                <span className="margin-left-10">|</span>
                <span> © כל הזכויות שמורות לאתר סיום הש"ס</span>
            </div>
        </div>
    );
};

export default DisplaySiumAher;

